import { Options } from 'nuqs';

import { GetAssignmentProblemsResponseDto } from '@/dtos/responses/get-assignment-problems.response.dto';
import { cn } from '@/lib/utils';

import { GetAssignmentDescriptionResponseDto } from '../dtos/responses/get-assignment-description.response.dto';
import styles from './assignment-step.module.scss';

interface AssignmentStepProps {
  problemId: string | undefined;
  setProblemId: (
    value: string | ((old: string) => string | null) | null,
    options?: Options,
  ) => Promise<URLSearchParams>;
  problems:
    | GetAssignmentProblemsResponseDto['problems']
    | GetAssignmentDescriptionResponseDto['problems'];
}
const AssignmentStep = (props: AssignmentStepProps) => {
  const { problemId, setProblemId, problems } = props;
  return (
    <div className="pb-4 border-b mb-4">
      <ul className="flex flex-row flex-wrap gap-3">
        {problems.map((problem, index) => {
          return (
            <button
              type="button"
              key={problem.id}
              className={styles.step}
              onClick={() => {
                setProblemId(problem.id);
              }}
            >
              <span
                className={cn(styles.step_number, problemId === problem.id ? styles.current : '')}
              >
                {index + 1}
              </span>
              <span
                className={cn(
                  'text-sm whitespace-nowrap',
                  problemId === problem.id ? 'text-primary font-bold' : '',
                )}
              >
                문제 {index + 1}
              </span>
            </button>
          );
        })}
      </ul>
    </div>
  );
};

export default AssignmentStep;
